import script from "./TheHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheHeader.vue?vue&type=script&setup=true&lang=ts"

import "./TheHeader.vue?vue&type=style&index=0&id=1acfed50&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1acfed50"]])

export default __exports__